import { getAllMenuList } from '@/api/menu';
import { getPsnlWorkInfo } from '@/api/main';
import {
  getWorkOverTimeInfo,
  getOrgWorkStaByAuthList,
  getHolidayStaInfo,
} from '@/api/workStatus';
import { getHolWork } from '@/api/application';
import { getApprDocList } from '@/api/allDoc.js';
import { getAnnualPlanYearList } from '@/api/annualPlan';
import { getMissingInfo } from '@/api/workLog';

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

const menuStore = {
  namespaced: 'MENU',
  state: {
    // [*] 전체메뉴목록
    allMenuList: [],
    subMenuList: [],

    // [*] 신청서메뉴 사용여부
    applMenuUseYn: false,

    // [*] 메인위젯 사용여부
    widgetUseObj: {
      apprDoc: false,
      orgGntWorkL: false,
      orgGntWorkB: false,
      workTime: false,
      pay: false,
      myBox: false,
      workLog: false,
      overtimeApp: false,
      annualHoliday: false,
      maternity: false,
      annualPlan: false,
      workOverTime: false,
      holidayWork: false,
    },

    // [*] 메인위젯 관련 데이터
    inOutInfo: {
      inOutGubun: '', // 출퇴근처리구분(1:출근필요,2:퇴근필요)
    },
    psnlWorkInfo: {}, // 개인근무정보
    apprDocCnt: 0, // 결재할문서건수
    orgList: [], // 조직목록
    empListByOrg: [], // 조직별조직원목록
    maternityHolidayRestCnt: 0, // 배우자출산휴가 잔여일수
    workOverRestTime: 0, // 연장근무보상시간
    holWorkList: [], // 휴일근무목록
    workLogMissingInfo: {}, // 업무일지 미작성건 정보

    // [*] 부서원근태현황 관련 데이터
    empInoutUseYn: false, // 일반직원 출퇴근 정보 사용여부 (22.12.23 기능추가)

    // [*] 연차계획작성 관련 데이터
    planYearData: {}, // 년도 데이터
    planAbFlag: 'B', // 제출 전/후 플래그
    mainShowFlag: false, // 메인 위젯 노출여부
    orgLvl: '',
    fetchInHm: '',
    fetchOutHm: '',
  },

  getters: {
    GET_MENU_LIST(state) {
      return state.allMenuList;
    },

    GET_APPL_MENU_USE_YN(state) {
      return state.applMenuUseYn;
    },

    GET_WIDGET_USE_OBJ(state) {
      return state.widgetUseObj;
    },

    GET_IN_OUT_INFO(state) {
      return state.inOutInfo;
    },

    GET_PSNL_WORK_INFO(state) {
      return state.psnlWorkInfo;
    },

    GET_APPR_DOC_CNT(state) {
      return state.apprDocCnt;
    },

    GET_EMP_LIST_BY_ORG(state) {
      return state.empListByOrg;
    },

    GET_MATERNITY_REST_CNT(state) {
      return state.maternityHolidayRestCnt;
    },

    GET_WORK_OVER_REST_TIME(state) {
      return state.workOverRestTime;
    },

    GET_HOL_WORK_LIST(state) {
      return state.holWorkList;
    },

    GET_EMP_INOUT_USE_YN(state) {
      return state.empInoutUseYn;
    },

    GET_PLAN_AB_FLAG(state) {
      return state.planAbFlag;
    },

    GET_PLAN_YEAR_DATA(state) {
      return state.planYearData;
    },

    GET_MAIN_SHOW_FLAG(state) {
      return state.mainShowFlag;
    },

    GET_WORK_LOG_MISSING_INFO(state) {
      return state.workLogMissingInfo;
    },
    GET_ORG_LVL(state) {
      return state.orgLvl;
    },
    GET_FETCH_IN_HM(state) {
      return state.fetchInHm;
    },
    GET_FETCH_OUT_HM(state) {
      return state.fetchOutHm;
    },
  },

  mutations: {
    // 메인관련 데이터 초기화
    SET_INIT_MAIN_DATA(state) {
      // 데이터 깜빡임 현상 방지 주석처리
      // state.widgetUseObj.apprDoc = false;
      // state.widgetUseObj.orgGntWorkL = false;
      // state.widgetUseObj.orgGntWorkB = false;
      // state.widgetUseObj.workTime = false;
      state.widgetUseObj.pay = false;
      state.widgetUseObj.myBox = false;
      state.widgetUseObj.workLog = false;
      state.widgetUseObj.overtimeApp = false;
      // state.widgetUseObj.annualHoliday = false;
      state.widgetUseObj.maternity = false;
      state.widgetUseObj.annualPlan = false;
      state.widgetUseObj.workOverTime = false;
      state.widgetUseObj.holidayWork = false;

      // state.inOutInfo.inOutGubun = '';
      // state.psnlWorkInfo = {};
      // state.apprDocCnt = 0;
      // state.orgList = [];
      // state.empListByOrg = [];
      state.maternityHolidayRestCnt = 0;
      state.workOverRestTime = 0;
      state.holWorkList = [];
      state.orgLvl = 0;
      // state.fetchInHm = '00:00';
      //state.fetchOutHm = '00:00';
    },

    // 전체메뉴목록 세팅
    SET_MENU_LIST(state, data) {
      state.allMenuList = data;
    },

    SET_SUB_MENU_LIST(state, data) {
      state.subMenuList = data;
    },

    // 신청서메뉴사용여부 세팅
    SET_APPL_MENU_USE_YN(state, data) {
      state.applMenuUseYn = data;
    },

    SET_ORG_LVL(state, data) {
      state.orgLvl = data;
    },

    // SET_FETCH_IN_HM(state, data) {
    //   state.fetchInHm = data;
    // },

    // SET_FETCH_OUT_HM(state, data) {
    //   state.fetchOutHm = data;
    // },

    // 위젯사용여부 세팅
    SET_WIDGET_USE_OBJ(state, data) {
      state.widgetUseObj[data] = true;
    },

    // 개인근무정보(출퇴근정보, 근무현황, 연차현황) 세팅
    SET_PSNL_WORK_INFO(state, data) {
      state.inOutInfo.inOutGubun = data.inHm != null ? '2' : '1';
      state.psnlWorkInfo = data;
      state.fetchInHm =
        data.inHm != null
          ? data.inHm.substr(0, 2) + ':' + data.inHm.substr(2, 2)
          : '-';
      state.fetchOutHm =
        data.outHm != null
          ? data.outHm.substr(0, 2) + ':' + data.outHm.substr(2, 2)
          : '-';
    },

    // 조직별 근무현황 세팅 (+위젯)
    SET_ORG_WORK_STA(state, data) {
      state.orgList = Object.keys(data.orgInfo);
      state.empListByOrg = data.listOfEmpByOrg[state.orgList[0]];

      if (state.orgList.length == 1 && state.empListByOrg.length <= 10) {
        state.widgetUseObj['orgGntWorkL'] = true;
      } else {
        state.widgetUseObj['orgGntWorkB'] = true;
      }
    },

    // 배우자출산휴가 잔여일 세팅 (+위젯)
    SET_MATERNITY_REST_CNT(state, data) {
      state.maternityHolidayRestCnt = data.yearRestCnt - data.appCnt;

      if (state.maternityHolidayRestCnt > 0) {
        state.widgetUseObj['maternity'] = true;
      }
    },

    // 연장근무보상 잔여시간 세팅 (+위젯)
    SET_WORK_OVER_REST_TIME(state, data) {
      state.workOverRestTime = data;

      if (state.workOverRestTime > 0) {
        state.widgetUseObj['workOverTime'] = true;
      }
    },

    // 휴일근무내역 세팅 (+위젯)
    SET_HOL_WORK_LIST(state, data) {
      state.holWorkList = data;

      if (state.holWorkList.length > 0) {
        state.widgetUseObj['holidayWork'] = true;
      }
    },

    // 결재할문서 건수 세팅 (+위젯)
    SET_APPR_DOC_CNT(state, data) {
      state.apprDocCnt = data;
    },

    // 부서원근태현황 관련
    SET_EMP_INOUT_USE_YN(state, data) {
      state.empInoutUseYn = data;
    },

    // 휴가계획작성 관련
    SET_PLAN_AB_FLAG(state, data) {
      state.planAbFlag = data;
    },

    SET_MAIN_SHOW_FLAG(state, data) {
      state.mainShowFlag = data;
    },

    SET_WORK_LOG_MISSING_INFO(state, data) {
      state.workLogMissingInfo = data;
    },
  },

  actions: {
    /* 메인 데이터 조회 */
    async FETCH_MAIN_DATA({ dispatch, commit }) {
      try {
        await dispatch('FETCH_ANNUAL_PLAN_DATA');
        await dispatch('FETCH_ALL_MENU_LIST');
        await dispatch('SET_MAIN_WIDGET_DATA');
      } catch (error) {
        console.log(error);
      }

      commit('SPINNER/OFF_COMMON_SPINNER', {}, { root: true }); // 상위나 형제 actions 접근시
    },

    /* 메뉴 목록 api 조회 */
    async FETCH_ALL_MENU_LIST({ rootGetters, state, commit }) {
      try {
        const response = await getAllMenuList({
          orgChiefYn: rootGetters.GET_USER_DATA.orgChiefYn, // 조직장여부
          planMenuFlag: state.planAbFlag,
        });

        const data = response.data.data;

        commit('SET_MENU_LIST', data.allMenuList);
        commit('SET_SUB_MENU_LIST', data.subMenuList);
        commit('SET_APPL_MENU_USE_YN', data.applMenuUseYn);
      } catch (error) {
        console.log(error);
      }
    },

    /* 메인 위젯 데이터 셋팅 */
    async SET_MAIN_WIDGET_DATA({ state, commit, dispatch }) {
      commit('SET_INIT_MAIN_DATA');
      state.subMenuList.forEach(subMenu => {
        switch (subMenu.menuCd) {
          case '101': // 근무현황
            commit('SET_WIDGET_USE_OBJ', 'workTime');
            break;
          case '103': // 연차현황
            commit('SET_WIDGET_USE_OBJ', 'annualHoliday');
            break;
          case '106': // 급여확인
            commit('SET_WIDGET_USE_OBJ', 'pay');
            break;
          case '202': // 내문서함
            commit('SET_WIDGET_USE_OBJ', 'myBox');
            break;
          case '305': // 연장근무신청
            commit('SET_WIDGET_USE_OBJ', 'overtimeApp');
            break;
          case '201': // 결재할문서
            commit('SET_WIDGET_USE_OBJ', 'apprDoc');
            dispatch('FETCH_APPR_DOC_LIST'); // >>> 결재할문서조회 호출
            break;
          case '204': // 업무일지
            commit('SET_WIDGET_USE_OBJ', 'workLog');
            dispatch('FETCH_MISSING_INFO'); // >>> 업무일지미작성건조회 호출
            break;
          case '102': // 부서원근태현황
            dispatch('FETCH_ORG_WORK_STA_BY_AUTH_LIST');
            if (
              subMenu.note != undefined &&
              subMenu.note != null &&
              subMenu.note === 'Y'
            )
              commit('SET_EMP_INOUT_USE_YN', true); // 일반직원 출퇴근 정보 사용여부 세팅
            break;
          case '104': // 배우자출산휴가
            dispatch('FETCH_HOLIDAY_STA_INFO'); // >>> 휴가현황정보조회 호출 -> 위젯값 세팅
            break;
          case '311': // 연차휴가계획작성
            commit('SET_WIDGET_USE_OBJ', 'annualPlan');
            break;
          case '105': // 연장근무보상시간
            dispatch('FETCH_WORK_OVER_TIME_INFO'); // >>> 연장근무보상시간정보조회 호출 -> 위젯값 세팅
            break;
          case '307': // 휴일근무현황
            dispatch('FETCH_HOL_WORK'); // >>> 휴일근무일조회 호출 -> 위젯값 세팅
            break;
        }
      });

      // >>> 개인근무정보조회 호출
      dispatch('FETCH_PSNL_WORK_INFO');
    },

    /* 연차계획작성 메뉴노출구분 조회 */
    async FETCH_ANNUAL_PLAN_DATA({ rootGetters, commit }) {
      try {
        const response = await getAnnualPlanYearList({
          searchSabun: rootGetters.GET_USER_DATA.ssnSabun,
        });
        const yearList = response.data.data;
        const curYear = dayjs().year().toString();

        // 현재년도 데이터
        const curYearDataList = yearList.filter(obj => obj.year === curYear);
        if (curYearDataList.length === 1) {
          const yearData = curYearDataList[0];

          // 계획 제출 전 : 'B', 제출 후 : 'A'
          const closeYn = yearData.closeYn;
          commit('SET_PLAN_AB_FLAG', closeYn === 'Y' ? 'A' : 'B');

          if (closeYn === 'Y') {
            // 계획제출 후 ? 메인노출x
            commit('SET_MAIN_SHOW_FLAG', false);
          } else {
            // 계획제출 전 ? 촉진기간 확인
            const curDate = dayjs();
            const firstPeriod = curDate.isBetween(
              yearData.plan1stSYmd,
              yearData.plan1stEYmd,
            ); // 1차촉진기간
            const secondPeriod = curDate.isBetween(
              yearData.plan2ndSYmd,
              yearData.plan2ndEYmd,
            ); // 2차촉진기간

            // 촉진기간에 따라 메인노출
            commit('SET_MAIN_SHOW_FLAG', firstPeriod || secondPeriod);
          }
        } else {
          // 현재년도 데이터 여러개일때 신청 불가
          commit('SET_MAIN_SHOW_FLAG', false);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 개인근무정보조회 */
    async FETCH_PSNL_WORK_INFO({ commit }) {
      try {
        const response = await getPsnlWorkInfo(); // 조회기준일 = 현재일자
        const data = response.data.data;

        commit('SET_PSNL_WORK_INFO', data);
      } catch (error) {
        console.log(error);
      }
    },

    /* 부서원근태현황조회 */
    async FETCH_ORG_WORK_STA_BY_AUTH_LIST({ rootGetters, commit }) {
      try {
        const paramObj = {
          searchDate: dayjs().format('YYYYMMDD'),
          orgChiefYn: rootGetters.GET_USER_DATA.orgChiefYn,
          authGroup: rootGetters.GET_USER_DATA.authGroup.toString(),
        };
        const response = await getOrgWorkStaByAuthList(paramObj);
        const dataObj = response.data.data;

        // 조회결과가 있을 때 세팅
        if (Object.keys(dataObj).length > 0) {
          commit('SET_ORG_WORK_STA', dataObj);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* (배우자출산)휴가현황 정보조회  */
    async FETCH_HOLIDAY_STA_INFO({ rootGetters, commit }) {
      try {
        const response = await getHolidayStaInfo({
          searchSabun: rootGetters.GET_USER_DATA.ssnSabun,
          gntGubunCd: '41',
        });
        const holidayStaInfo = response.data.data.holidayStaInfo;

        if (holidayStaInfo != null) {
          commit('SET_MATERNITY_REST_CNT', holidayStaInfo);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 연장근무보상시간 정보조회  */
    async FETCH_WORK_OVER_TIME_INFO({ rootGetters, commit }) {
      try {
        const response = await getWorkOverTimeInfo({
          searchSabun: rootGetters.GET_USER_DATA.ssnSabun,
        });
        const dataObj = response.data.data;

        if (dataObj.restTime != null) {
          commit('SET_WORK_OVER_REST_TIME', dataObj.restTime);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 휴일근무일 조회 */
    async FETCH_HOL_WORK({ rootGetters, commit }) {
      try {
        const paramObj = {
          searchApplSabun: rootGetters.GET_USER_DATA.ssnSabun,
          searchApplSeq: 0, // 조회목록 제외 신청서 (없음)
          applStatusCd: '',
        };
        const response = await getHolWork(paramObj);
        const responseList = response.data.data;

        if (responseList != null && responseList.length !== 0) {
          commit('SET_HOL_WORK_LIST', responseList);
        }
      } catch (error) {
        console.log(error);
      }
    },

    /* 결재할문서 조회 */
    async FETCH_APPR_DOC_LIST({ commit }) {
      try {
        const paramObj = {
          searchFrom: dayjs().subtract(1, 'month').format('YYYYMMDD'),
          searchTo: dayjs().format('YYYYMMDD'), // 조회기간(한달전~현재)
          multiSearchApplCd:
            "'11','12','13','14','22','23','30','42','43','110','301','201'", // 조회신청서코드(제증명, 근무,근태관련)
        };
        const response = await getApprDocList(paramObj);
        const dataList = response.data.data;

        commit('SET_APPR_DOC_CNT', dataList.length);
      } catch (error) {
        console.log(error);
      }
    },

    /** 업무일지 미작성건 조회 */
    async FETCH_MISSING_INFO({ commit }) {
      const response = await getMissingInfo();
      const dataObj = response.data.data;
      commit('SET_WORK_LOG_MISSING_INFO', dataObj);
    },
  },
};

export default menuStore;
